import { render, staticRenderFns } from "./DocumentInput.vue?vue&type=template&id=1b6fe844&"
import script from "./DocumentInput.vue?vue&type=script&lang=js&"
export * from "./DocumentInput.vue?vue&type=script&lang=js&"
import style0 from "./DocumentInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DocumentInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VLabel } from 'vuetify/lib/components/VLabel';
installComponents(component, {VIcon,VInput,VLabel})
